import { filter, flatten, last, map } from 'lodash'
import moment from 'moment'
import { useEffect } from 'react'

import useFieldState from '../../../../../../../../../../1stlog-ui/src/components/Field/useFieldState'
import useFieldValue from '../../../../../../../../../../1stlog-ui/src/components/Field/useFieldValue'

type UseAdditionalServiceControlledTimeProps = {
  mode: string
  isPickup: boolean
  until: string
}

export function useAdditionalServiceControlledTime(
  props: UseAdditionalServiceControlledTimeProps,
): void {
  const { mode, isPickup, until: originalUntil } = props

  const [until, setUntil] = useFieldState<string>('until')

  const [_, setUntilAlwaysValid] = useFieldState<boolean>('untilAlwaysValid')

  const colis: any[] = useFieldValue('colis', {
    ignorePrefix: true,
  })

  useEffect(() => {
    if (isPickup || mode !== 'default' || !until || until === '') {
      return
    }
    const earliestDeliveryTimeUntil =
      getAdditionalServiceDeliveryUntilTime(colis)
    if (!earliestDeliveryTimeUntil) {
      setTimeout(() => {
        setUntil(originalUntil)
        setUntilAlwaysValid(false)
      }, 1)
      return
    }
    const [hours, minutes, seconds] = earliestDeliveryTimeUntil.split(':')

    const newTime = moment(originalUntil)
      .hours(Number(hours))
      .minutes(Number(minutes))
      .seconds(Number(seconds))
      .toISOString()

    setTimeout(() => {
      if (moment(newTime).isBefore(moment())) {
        setUntil(originalUntil)
        setUntilAlwaysValid(false)
        return
      }
      setUntil(newTime)
      setUntilAlwaysValid(true)
    }, 1)
  }, [colis, mode, isPickup, originalUntil])
}

function getAdditionalServiceDeliveryUntilTime(colis: any[]): string | null {
  const times = flatten(
    map(filter<any>(colis, Boolean), (coli) =>
      map(coli?.services, (service) =>
        service.isEnabled ? service.earliestDeliveryTimeUntil : null,
      ),
    ),
  ).filter(Boolean)
  // const times = ['15:00:00', '12:00:00', '17:00:00']
  const sortedTimes = map(times, (t) => moment(t, 'HH:mm:ss').toDate()).sort()
  return last(map(sortedTimes, (t) => moment(t).format('HH:mm:ss'))) || null
}
